module.exports = __webpack_public_path__ + "static/1-92c32d01806bb46908de1cd660901b85.png";